module.exports = __webpack_public_path__ + "static/52ea7bc6-3b7f-4c8f-922a-a2d393e5c8c2-700.11bd8c49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-katharines-chapel-window/52ea7bc6-3b7f-4c8f-922a-a2d393e5c8c2-700.jpg
// module id = 1107
// module chunks = 168707334958949